import { useMemo } from 'react'
import { graphql, Script } from 'gatsby'
import tw from 'twin.macro'

import CTALink, { CtaLinkProps } from '@/components/ui/cta-link'

export const fragment = graphql`
  fragment HubspotCTA on ContentfulComponentHubspotCta {
    id
    __typename
    node_locale
    label
    embedCode {
      embedCode
    }
    size
    variant: style
    display
    icon {
      ...Icon
    }
  }
`

export type HubspotCTAProps = Omit<CtaLinkProps, 'to'> & {
  embedCode: Queries.ContentfulComponentHubspotCta['embedCode']
}

function HubspotCTA({ embedCode, children, ...props }: HubspotCTAProps): JSX.Element {
  const { hubspotId, href } = useMemo(
    () => ({
      hubspotId: embedCode.embedCode.match(/data-hubspot-wrapper-cta-id="(\d+)"/)?.[1],
      href: embedCode.embedCode.match(/href="([^"]+)"/)?.[1],
    }),
    [embedCode]
  )

  return (
    <>
      <CTALink to={href} {...props}>
        {children}
      </CTALink>
      <div
        css={tw`hidden`}
        className={`hs-cta-embed hs-cta-simple-placeholder hs-cta-embed-${hubspotId}`}
        data-hubspot-wrapper-cta-id={hubspotId}
      />
      <Script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/22371289.js" />
    </>
  )
}

export default HubspotCTA
